import { RootState } from '@next/core-lib/app';
import { EntityState } from '@ngrx/entity';

import { Barn } from '../../settings/models/settings.model';

export interface AnimalGroupModuleState extends RootState {
  animalGroups?: AnimalGroupsState;
  selectedAnimalGroupId: number;
  selectedFeedadviceApplicationId: number;
  isLoaded: boolean;
}

export type AnimalGroupsState = EntityState<AnimalGroup>;

export interface AnimalGroupsResponse {
  animalGroups: AnimalGroup[];
}
export interface UpsertAnimalGroupResponse {
  id: number;
}

export interface AnimalGroup {
  id: number;
  name: string;
  description: string;
  startDate: string;
  endDate?: string;
  productionType: ProductionType;
  supplySystemType: SupplySystemType;
  barn: Barn;
  sectionNames: string[];
  observation: Observation;
  feedAdviceApplications: FeedAdviceApplication[];
}

export interface FeedAdviceApplication {
  id: number;
  feedAdviceId: number;
  feedAdviceName?: string;
  feedAdviceApplicabilityPercentage: number;
  startDate: string;
  endDate?: string;
}

export interface Observation {
  realizedFeedIntakeGPerDay?: number;
  realizedGrowthGPerDay?: number;
  realizedFeedConversionRate?: number;
  startWeight?: number;
}

export enum ProductionType {
  FatteningPigs = 'FatteningPigs',
  RearingPigs = 'RearingPigs',
  SowsBtF = 'SowsBtF',
  SowsFtW = 'SowsFtW',
  SowsWtB = 'SowsWtB',
  WeanedPiglets = 'WeanedPiglets',
}
export enum SupplySystemType {
  AllInAllOut = 'AllInAllOut',
  Continuous = 'Continuous',
}
